// extracted by mini-css-extract-plugin
export default {"button":"IncrementButton_button__9QeXn"};